export default __webpack_public_path__ + "static/media/cabinet1-after-1440w.7360d5b1.webp";